<template>
<div class="surveillance-referent-modal">
  <modal v-model="referentModal"
         :footer="false"
         :z-offset="-100"
         :header="false">
    <div v-if="activeUsers.length === 0">
      Chargement des utilisateurs
    </div>
    <div v-else>
      <div v-if="referentModal"
           class="referent-modal">
        <div class="referent-div-with-padding">
          <h3>
            {{ surveillance.establishment.name }}
          </h3>
          <div class="form-group">
            <strong>Responsable actuel</strong>
            <input class="form-control" disabled="true" :value="currentReferent">
          </div>
          <div v-if="conventionReceived && currentYear">
            <div class="form-group">
              <c-checkbox v-model="refuse" type="bactADI" size="sm">
                Refuser la charte
              </c-checkbox>
            </div>
            <alert type="info" v-if="refuse">
              <h4>Attention !</h4>
              <p>
                Modifier le responsable de cette inscription invalidera
                automatiquement sa charte. Si vous souhaitez la sauvegarder
                avant de modifier le responsable, cliquez sur le bouton ci-dessous
              </p>
              <p>
                <btn type="default"
                     @click="downloadConvention()">
                  Télécharger la charte
                </btn>
              </p>
              <save-blob :target="convention"></save-blob>
            </alert>
          </div>
          <div class="form-group">
            <strong class="input-label">Nouveau responsable</strong>
            <div class="input-group">
              <input required
                     ref="input"
                     id="input"
                     tabindex="0"
                     class="form-control"
                     v-model="text"
                     type="text"
                     placeholder="Taper quelques lettres du nom, prénom ou e-mail"
                     autocomplete="off"/>
              <span class="input-group-btn">
                <btn type="warning"
                     :disabled="busy || result == null"
                     @click.once="askForConfirm">
                  Changer
                </btn>
              </span>
            </div>
            <typeahead v-model="result"
                       open-on-focus
                       force-select
                       target="#input"
                       :data="userList"
                       item-key="value"/>
          </div>
        </div>
      </div>
    </div>
  </modal>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

import assert from '@/sui/tools/assert'
import { confirm } from '@/sui/tools/modal'
import go from '@/gojs/go'
import saveBlob from '@/sui/components/saveblob'
import checkbox from '@/sui/components/checkbox'

export default {
  name: 'surveillance-referent-modal',

  props: {
    surveillance: Object,

    value: {
      type: Boolean,
      required: true
    },

    nested: {
      type: Boolean,
      default: false
    }
  },

  created () {
    if (this.activeUsers.length === 0) {
      this.$store.dispatch('user/all')
    }
  },

  data () {
    return {
      referentModal: this.value,
      text: '',
      result: null,
      busy: false,
      convention: null,
      refuse: false
    }
  },

  computed: {
    currentYear: function () {
      return go.date.currentYear === this.surveillance.year
    },

    ref: function () {
      if (this.surveillance == null) {
        return null
      }

      return this.surveillance.registrator
    },

    currentReferent: function () {
      if (this.ref == null) {
        return ''
      }

      return this.formatUser(this.ref)
    },

    ...mapGetters({
      activeUsers: 'user/active'
    }),

    userList: function () {
      const id = this.ref != null ? this.ref.id : ''
      const reducer = (result, u) => {
        if (u.id !== id) {
          result.push({ id: u.id, value: `${u.firstName} ${u.name} (${u.email})` })
        }
        return result
      }
      return this.activeUsers.reduce(reducer, [])
    },

    conventionReceived () {
      return this.surveillance != null && this.surveillance.cvt.stat !== ''
    }
  },

  watch: {
    referentModal: {
      handler: function () {
        this.$emit('input', this.referentModal)
        if (!this.referentModal) {
          this.result = null
          this.text = ''
        }
      },
      deep: true
    },

    value: function (value) {
      this.referentModal = value
    }
  },

  methods: {

    askForConfirm: function () {
      const v = this.result.value
      const n = this.surveillance.establishment.name
      confirm(
        this,
        `Êtes-vous sûr.e de vouloir désigner
<strong>${v}</strong> comme responsable principal de la
inscription pour l'établissement <strong>
${n}</strong> ?`
      ).then(() => {
        this.updateReferent()
      }).catch(() => {})
    },

    updateReferent: function () {
      assert.notNull(this.result)

      let request = {}
      let uri = ''
      if (this.surveillance.year === 2019) {
        request = {
          s: this.surveillance.id,
          u: this.result.id,
          year: this.surveillance.year
        }
        uri = 'surveillances/updateReferent'
      } else {
        request = {
          surv: this.surveillance.id,
          user: this.result.id,
          year: this.surveillance.year,
          refc: this.currentYear && this.refuse
        }
        uri = 'surveillances/updateRegistrator'
      }

      this.busy = true
      const vm = this
      const user = this.result.value
      const establishment = this.surveillance.establishment.name
      this.$store.dispatch(uri, request).then(
        function (response) {
          if (response.data.err != null) {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une erreur est survenue pendant la mise à jour du
responsable : ${response.data.err}.`
            })
          } else {
            vm.$notify({
              type: 'success',
              title: 'Succès !',
              content: `${user} est maintenant responsable de l'inscription pour
l'établissement ${establishment}.`
            })
          }
          vm.busy = false
          vm.referentModal = false
        }
      ).catch(
        function (e) {
          vm.$notify({
            type: 'danger',
            title: 'Erreur !',
            duration: 0,
            content: `Une erreur est survenue pendant la mise à jour du responsable : ${e.toString()}.`
          })
          vm.busy = false
          vm.referentModal = false
        }
      )
    },

    formatUser: function (u) {
      return `${u.firstName} ${u.name} (${u.emails})`
    },

    downloadConvention: function () {
      let request = {
        id: this.surveillance.id
      }

      const year = this.surveillance.year
      let target = {
        filename: `SPIADI${year} - Charte - ${this.surveillance.establishment.name}.pdf`,
        blob: null
      }
      this.$store.dispatch('surveillances/downloadConvention', request)
        .then(response => {
          target.blob = new Blob([response.data], { type: 'application/pdf' })
          this.convention = target
        }
        )
    }
  },

  components: {
    'save-blob': saveBlob,
    'c-checkbox': checkbox
  }
}
</script>

<style lang="less">
.referent-modal {
    .referent-div-with-padding {
        margin-bottom: 4rem;
    }
    .input-label {
        min-width: 15rem;
    }
}
</style>
